export const ORIENTATIONS = {
  VERTICAL: "vertical",
  PORTRAIT: "portrait",
  LANDSCAPE: "landscape"
};

export const orientationsOptions = [
  { value: ORIENTATIONS.VERTICAL, label: "Vertical" },
  { value: ORIENTATIONS.PORTRAIT, label: "Portrait" },
  { value: ORIENTATIONS.LANDSCAPE, label: "Landscape" }
];

export const VIEW_SELECTOR = {
  SINGLE: "single",
  ALL_DRAFTS: "all-drafts"
};
